module.exports = __webpack_public_path__ + "static/media/global-shoppng-icon.8ea4a012.svg";